export function initSort() {
  const sortButton = document.querySelector(".sort__button");
  const sortList = document.querySelector(".sort__list");
  const sortItems = document.querySelectorAll(".sort__item");
  const sortButtonText = document.querySelector(".sort__button-text");

  if (!(sortButton && sortList && sortItems.length && sortButtonText)) return;

  sortButton.addEventListener("click", function (event) {
    event.stopPropagation();

    sortList.classList.toggle("active");
  });

  document.addEventListener("click", function (event) {
    if (
      !sortList.contains(event.target) &&
      !sortButton.contains(event.target)
    ) {
      sortList.classList.remove("active");
    }
  });

  sortItems.forEach(item => {
    item.addEventListener("click", function () {
      const sortBy = item.dataset?.orderby,
        direction = item.dataset?.order;

      console.log(sortItems);
      console.log(item);

      sortButtonText.innerHTML = item.innerHTML;

      sortList.classList.remove("active");

      sortContent(sortBy, direction);
    });

    // Функцию сортировки  сделать
    function sortContent(sortBy, direction) {
      const sourceUrl = `${window.location.origin}${window.location.pathname}`;
      window.location.href = `${sourceUrl}?orderby=${sortBy}&order=${direction}`;
    }
  });
}
